import { Action } from '@ngrx/store';
import { Manager } from '../../../global/interfaces';

export enum ActionTypes {
  LOAD_MANAGERS = '[My Contacts] Load Managers Action',
  LOAD_MANAGERS_SUCCESS = '[My Contacts] Load Managers Success Action',
  LOAD_MANAGERS_FAILED = '[My Contacts] Load Managers'
}

export class LoadManagersAction implements Action {
  readonly type = ActionTypes.LOAD_MANAGERS;

  public constructor(public payload: any) {
  }
}

export class LoadManagersSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_MANAGERS_SUCCESS;

  public constructor(public payload: Manager[]) {
  }
}

export class LoadManagersFailedAction implements Action {
  readonly type = ActionTypes.LOAD_MANAGERS_FAILED;

  public constructor(public payload: any) {
  }
}

export type Actions =
  LoadManagersAction |
  LoadManagersSuccessAction |
  LoadManagersFailedAction;
